import { connect } from 'react-redux';
import withPGTranslation from '../../config/withPGTranslation';
import SideMenu from './side_menu';

const mapStateToProps = ({ user, application }) => ({
  isSufficientForCashback: user.user ? user.user.isSufficientForCashback : false,
  cashbackAmount: user.user ? user.user.cashbackAmount : '0.0',
  shouldShowPayoutMethodMenuItem:
    user.user && user.user.settings
      ? !!user.user.settings.showPaymentMethodMenuItem : true,
  showSpiritualHubMenuItem: application.dynamicConfig?.showSpiritualHubMenuItem ?? false,
  showNewSpiritualHubBadge: (user.user?.badgeCounters?.newSpiritualHubCountTotal ?? 0) > 0,
  satisfactionGuarantee: application.dynamicConfig?.uiSettings?.satisfactionGuarantee,
  showAddFundsMenuItem: user.user?.settings?.showAddFundsMenuItem ?? false,
  currencyCode: application.dynamicConfig?.currency || 'USD'
});

export default connect(
  mapStateToProps
)(withPGTranslation(SideMenu));
